import { getDirectusUrl } from "@/config/config";
import {
  DirectusAvailableLanguages,
  DirectusEntities,
} from "./types/directus.types";

export class DirectusService {
  public static url = getDirectusUrl();

  static buildEntityQuery(entity: DirectusEntities) {
    return `${this.url}/items/${entity}?fields[]=*.*`;
  }

  static buildGetArticleBySlugQuery(slug: string) {
    return `${this.url}/items/articles?deep[translations][_filter][slug][_eq]=${slug}&fields[]=*.*,translations.seo.seo_id.*,translations.seo.seo_id.og_image.*, tags.tags_id.*`;
  }

  static buildGetSEOByIdQuery(id: string) {
    return `${this.url}/items/seo/${id}?fields[]=*.*`;
  }

  static buildgetAllArticlesByTagQuery(
    language: DirectusAvailableLanguages,
    tagName: string
  ) {
    return `${this.url}/items/articles?deep[translations][_filter][languages_code][_eq]=${language}&filter[tags][tags_id][name][_eq]=${tagName}&fields[]=*.*`;
  }

  static addAuthBearer(fetchConfig) {
    const updatedHeaders = { ...fetchConfig };
    updatedHeaders.headers.Authorization = `Bearer ${process.env.DIRECTUS_TOKEN_API_ROLE_ACCESS}`;

    return updatedHeaders;
  }

  static addLanguageToQuery(query: string, lang: DirectusAvailableLanguages) {
    const newQuery = query + `&filter[languages_code][_eq]=${lang}`;

    return newQuery;
  }
}
